import { render, staticRenderFns } from "./ContractRenewalApproval.vue?vue&type=template&id=0c4b504b"
import script from "./ContractRenewalApproval.vue?vue&type=script&lang=js"
export * from "./ContractRenewalApproval.vue?vue&type=script&lang=js"
import style0 from "./ContractRenewalApproval.vue?vue&type=style&index=0&id=0c4b504b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports